import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../foundation/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  readonly invalid?: boolean;
}

const BASE =
  'h-10 w-full rounded-token border bg-bg px-3 text-sm text-fg placeholder:text-fg-muted ' +
  'transition-colors duration-fast ease-standard ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary ' +
  'disabled:cursor-not-allowed disabled:opacity-60';

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid = false, className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(BASE, invalid ? 'border-danger' : 'border-input-border', className)}
      {...rest}
    />
  );
});
